import type { ChatWidgetTranslation } from './types';

export const chatWidgetUr: ChatWidgetTranslation = {
  nav: 'چیٹ وِجٹ',
  title: 'چیٹ وِجٹ',
  description:
    'آپ کی ویب سائٹ پر چیٹ کیسی دکھتی اور کیسے کام کرتی ہے، گاہکوں سے کیا پوچھتی ہے، اور اسے کیسے شیئر کریں۔ ہر ٹیب الگ سے محفوظ ہوتا ہے، اور تبدیلیاں ایک منٹ میں ویب سائٹس تک پہنچ جاتی ہیں۔',
  loading: 'چیٹ وِجٹ کی سیٹنگز لوڈ ہو رہی ہیں',
  brand: 'برانڈ',
  open: 'چیٹ وِجٹ',
  openLabel: '{{name}} کے لیے چیٹ وِجٹ کی سیٹنگز',
  noPermission: 'آپ کا کردار چیٹ وِجٹ نہیں بدل سکتا۔ ورک اسپیس کے مالک یا ایڈمن سے کہیں۔',
  forbidden: {
    title: 'آپ چیٹ وِجٹ نہیں بدل سکتے',
    description: 'ورک اسپیس کے مالک یا ایڈمن سے ایسا کردار مانگیں جو چیٹ وِجٹ سیٹ کر سکے۔',
  },
  noBrands: {
    title: 'ابھی کوئی برانڈ نہیں ہے',
    description: 'پہلے ایک برانڈ اور اس کی ویب سائٹ شامل کریں۔ پھر یہاں اس کی چیٹ سیٹ کریں۔',
    action: 'برانڈز اور انسٹال پر جائیں',
  },
  tabs: {
    label: 'چیٹ کے حصے',
    look: 'شکل',
    behaviour: 'برتاؤ',
    forms: 'فارم',
    privacy: 'پرائیویسی',
    share: 'شیئر کریں',
  },
  unsaved: 'آپ کی کچھ تبدیلیاں محفوظ نہیں ہوئیں۔',
  reset: 'تبدیلیاں واپس لیں',
  guideLook: 'شکل کیسے بدلیں',
  preview: {
    note: 'محفوظ کرنے سے پہلے، آپ کی تبدیلیوں کے ساتھ چیٹ کی ایک تصویر۔ اصل چیٹ آزمانے کے لیے، برانڈز اور انسٹال پر ٹیسٹ چیٹ استعمال کریں۔',
    language: 'زبان',
    screen: 'دکھائیں',
    screens: {
      prechat: 'چیٹ شروع ہونے سے پہلے',
      offline: 'رابطہ فارم',
      thanks: 'بھیجنے کے بعد',
    },
    prechatOff: 'چیٹ سے پہلے والا فارم بند ہے: گاہک سیدھے چیٹ میں جاتے ہیں۔',
    offlineOff: 'رابطہ فارم بند ہے: گاہک پھر بھی لکھ سکتے ہیں، اور واپس آنے پر جواب پڑھ سکتے ہیں۔',
    consentOff: 'رضامندی بند ہے: چیٹ سے پہلے کسی سے رضامندی نہیں مانگی جاتی۔',
    layout: 'آپ کی ویب سائٹ پر: {{layout}}، {{side}}۔',
  },
  behaviour: {
    title: 'چیٹ کیسے کام کرتی ہے',
    description:
      'چیٹ کہاں دکھتی ہے، گاہک کیا بھیج اور ڈھونڈ سکتے ہیں، اور انہیں کون سی ای میلز ملتی ہیں۔',
  },
  forms: {
    guide: 'فارم کیسے کام کرتے ہیں',
    save: 'فارم محفوظ کریں',
    saved: '{{name}} کے فارم محفوظ ہو گئے۔ ایک منٹ میں ویب سائٹس پر نظر آئیں گے۔',
    prechat: {
      title: 'چیٹ شروع ہونے سے پہلے',
      description:
        'چیٹ شروع ہونے سے پہلے کچھ باتیں پوچھیں، تاکہ صحیح شخص ضروری معلومات کے ساتھ جواب دے۔ ہر اضافی سوال کا مطلب ہے کہ کم گاہک چیٹ شروع کریں گے۔',
      enabled: 'چیٹ شروع ہونے سے پہلے یہ سوال پوچھیں',
      enabledHint: 'بند ہونے پر، گاہک سیدھے لکھنا شروع کرتے ہیں۔',
      skipVerified: 'جن گاہکوں کو آپ کی ویب سائٹ نے سائن اِن کیا ہے، ان کے لیے سوال چھوڑ دیں',
      skipVerifiedHint:
        'آپ کی ویب سائٹ پہلے ہی بتا چکی ہے کہ وہ کون ہیں، اس لیے وہ سیدھے چیٹ میں جاتے ہیں۔',
    },
    offline: {
      title: 'جب جواب دینے کے لیے کوئی نہ ہو',
      description:
        'انتظار کرنے کے بجائے، گاہک ایک پیغام چھوڑتے ہیں۔ وہ اِن باکس میں ایک ٹکٹ بن جاتا ہے، اور پتہ تصدیق ہونے کے بعد جواب ان کی ای میل پر جاتا ہے۔',
      enabled: 'جب کوئی جواب نہ دے سکے تو رابطہ فارم دکھائیں',
      enabledHint: 'بند ہونے پر بھی گاہک چیٹ میں لکھ سکتے ہیں اور واپس آنے پر جواب پڑھ سکتے ہیں۔',
      when: 'کب دکھائیں',
      whens: {
        either: 'کام کے اوقات سے باہر، یا جب کوئی آن لائن نہ ہو',
        eitherHint: 'گاہک کبھی یہ جانے بغیر انتظار نہیں کرتے کہ کوئی موجود نہیں ہے۔',
        closed: 'صرف کام کے اوقات سے باہر',
        closedHint: 'اس کے لیے کام کے اوقات چاہییں۔ ان کے بغیر فارم کبھی نہیں دکھتا۔',
        nobody_online: 'صرف تب جب ٹیم میں کوئی آن لائن نہ ہو',
        nobody_onlineHint: 'کام کے اوقات میں بھی، جب سب دور یا آف لائن ہوں۔',
      },
      thanks: 'شکریے کا پیغام',
      thanksHint:
        'بھیجنے کے بعد گاہک کیا پڑھتے ہیں۔ خالی چھوڑنے پر Hamnivo کے اپنے الفاظ استعمال ہوتے ہیں (ہلکے رنگ میں دکھتے ہیں)۔ جب تک آپ دوسری زبانوں میں نہ لکھیں، وہ انگریزی دکھاتی ہیں۔',
      aiFirst: 'پہلے اے آئی اسسٹنٹ کو جواب دینے دیں',
      aiFirstHint:
        'اے آئی اسسٹنٹ پیغام کا جواب دینے کی کوشش کرتا ہے۔ ٹکٹ سونپنے پر لوگ آگے سنبھالتے ہیں۔',
      emailLocked: 'ہمیشہ پوچھا جاتا ہے اور لازمی ہے: جواب گاہک کو اسی پتے پر ملتا ہے۔',
      questionLocked: 'ہمیشہ پوچھا جاتا ہے اور لازمی ہے: آپ کی ٹیم اسی کا جواب دیتی ہے۔',
      lockedRemove: 'اس سوال کے بغیر رابطہ فارم کام نہیں کر سکتا۔',
    },
    fields: {
      legend: 'سوالات',
      count: '{{max}} میں سے {{n}} سوال',
      empty: 'ابھی کوئی سوال نہیں ہے۔ ایک شامل کریں، یا یہ فارم بند کریں۔',
      field: 'سوال {{number}}: {{name}}',
      kind: 'جواب کی قسم',
      kinds: {
        name: 'نام',
        email: 'ای میل پتہ',
        phone: 'فون نمبر',
        question: 'ان کا سوال',
        department: 'کس ٹیم سے بات کرنی ہے',
        text: 'مختصر جواب',
        choice: 'فہرست میں سے چنیں',
      },
      label: 'گاہک کیا پڑھتا ہے',
      labelHint: 'انگریزی لازمی ہے۔ جب تک آپ دوسری زبانوں میں نہ لکھیں، وہ انگریزی دکھاتی ہیں۔',
      required: 'گاہکوں کو اس کا جواب دینا ہوگا',
      moveUp: '{{name}} کو اوپر لے جائیں',
      moveDown: '{{name}} کو نیچے لے جائیں',
      moved: '{{name}} اب سوال {{number}} ہے۔',
      remove: '{{name}} ہٹائیں',
      removeShort: 'ہٹائیں',
      removed: '{{name}} ہٹا دیا گیا۔',
      add: 'سوال شامل کریں',
      added: '{{name}} آخر میں شامل کر دیا گیا۔',
      full: 'ایک فارم زیادہ سے زیادہ {{max}} سوال پوچھ سکتا ہے۔ دوسرا شامل کرنے کے لیے ایک ہٹائیں۔',
      options: 'چننے کے لیے جوابات',
      optionsHint: '{{min}} سے {{max}} جوابات۔',
      departmentHint: 'ہر جواب گفتگو کو ایک سپورٹ ٹیم کے پاس بھیجتا ہے۔',
      option: 'جواب {{number}}',
      team: 'جواب {{number}} کی ٹیم',
      teamPlaceholder: 'ٹیم منتخب کریں',
      noTeams: 'پہلے ایک سپورٹ ٹیم شامل کریں: ہر جواب کسی ٹیم تک جاتا ہے۔',
      noTeamsLink: 'سپورٹ ٹیموں پر جائیں',
      addOption: 'جواب شامل کریں',
      removeOption: '{{name}} کا جواب {{number}} ہٹائیں',
      otherLanguages: 'عربی، ہندی اور اردو (3 میں سے {{n}} لکھی گئیں)',
      optionsFull: 'ایک فہرست میں زیادہ سے زیادہ {{max}} جوابات ہو سکتے ہیں۔',
    },
    problems: {
      at: '{{form}}، سوال {{number}}',
      label: '{{at}}: انگریزی میں لکھیں کہ سوال میں کیا لکھا ہے۔',
      duplicateKind: '{{at}}: اس طرح کا جواب پہلے سے پوچھا گیا ہے۔ اسے ایک ہی بار پوچھیں۔',
      fewOptions: '{{at}}: کم از کم {{min}} جوابات دیں۔',
      manyOptions: '{{at}}: زیادہ سے زیادہ {{max}} جوابات دیں۔',
      optionLabel: '{{at}}: جواب {{option}} انگریزی میں لکھیں۔',
      optionTeam: '{{at}}: جواب {{option}} کے لیے ٹیم منتخب کریں۔',
      tooManyFields: '{{form}}: زیادہ سے زیادہ {{max}} سوال پوچھیں۔',
      needsEmail: 'رابطہ فارم میں لازمی ای میل پتہ ہونا چاہیے، تاکہ جواب گاہک تک پہنچے۔',
      needsQuestion:
        'رابطہ فارم میں گاہک کا سوال لازمی ہونا چاہیے، تاکہ آپ کی ٹیم جانے کہ کیا جواب دینا ہے۔',
      thanksEnglish: 'پہلے شکریے کا پیغام انگریزی میں لکھیں۔ دوسری زبانیں اسی پر لوٹتی ہیں۔',
      forms: {
        prechat: 'چیٹ سے پہلے والا فارم',
        offline: 'رابطہ فارم',
      },
    },
  },
  privacy: {
    title: 'چیٹ سے پہلے رضامندی',
    description:
      'چیٹ شروع ہونے سے پہلے گاہکوں سے رضامندی مانگیں۔ ان کی رضامندی ان الفاظ کے ورژن کے ساتھ رکھی جاتی ہے جن پر وہ متفق ہوئے۔',
    guide: 'رضامندی کیسے کام کرتی ہے',
    mode: 'کس سے پوچھا جائے',
    modes: {
      off: 'کسی سے نہیں',
      offHint: 'گاہک سیدھے چیٹ شروع کرتے ہیں۔',
      everyone: 'ہر وزیٹر سے',
      everyoneHint: 'ہر کوئی اپنے پہلے پیغام سے پہلے ایک بار رضامندی دیتا ہے۔',
      eu: 'صرف یورپی یونین، ای ای اے اور برطانیہ کے وزیٹرز سے',
      euHint: 'ہر وزٹ پر ہم دیکھتے ہیں کہ کنکشن کہاں سے آ رہا ہے، اور اسے کبھی محفوظ نہیں کرتے۔',
    },
    text: 'وہ الفاظ جن پر گاہک رضامندی دیتے ہیں',
    textHint:
      'خالی چھوڑنے پر Hamnivo کے اپنے الفاظ استعمال ہوتے ہیں (ہلکے رنگ میں دکھتے ہیں)۔ جب تک آپ دوسری زبانوں میں نہ لکھیں، وہ انگریزی دکھاتی ہیں۔',
    reconsent: 'الفاظ بدلنے پر، پہلے رضامندی دے چکے گاہکوں سے دوبارہ رضامندی مانگی جاتی ہے۔',
    reconsentNow:
      'آپ نے الفاظ بدلے ہیں: محفوظ کرنے کے بعد، پہلے رضامندی دے چکے گاہکوں سے دوبارہ پوچھا جائے گا۔',
    version: 'گاہکوں نے الفاظ کے ورژن {{version}} پر رضامندی دی ہے۔',
    versionNone: 'ابھی تک کسی نے رضامندی نہیں دی: یہ الفاظ محفوظ نہیں ہوئے۔',
    privacyLink: 'پرائیویسی پالیسی کا لنک',
    privacyLinkHint: 'سوال کے ساتھ دکھتا ہے۔ اسے آپ شکل والے ٹیب پر سیٹ کرتے ہیں۔',
    privacyNone: 'ابھی پرائیویسی پالیسی کا کوئی لنک نہیں ہے۔',
    privacyEdit: 'اسے شکل والے ٹیب پر بدلیں',
    save: 'رضامندی کی سیٹنگز محفوظ کریں',
    saved: '{{name}} کی رضامندی کی سیٹنگز محفوظ ہو گئیں۔',
    english: 'پہلے الفاظ انگریزی میں لکھیں۔ دوسری زبانیں انہی پر لوٹتی ہیں۔',
  },
  share: {
    link: {
      title: 'براہ راست چیٹ لنک',
      description:
        'ایک صفحہ جس پر صرف چیٹ ہے، جسے ای میل، سوشل میڈیا یا چھپی چیزوں میں شیئر کیا جا سکے۔',
      guide: 'براہ راست لنک کیسے کام کرتا ہے',
      enabled: 'لوگوں کو لنک سے چیٹ کھولنے دیں',
      enabledHint: 'اسے بند کرنے سے لنک سے کھولی گئی چیٹس ختم ہو جاتی ہیں۔',
      save: 'لنک کی سیٹنگ محفوظ کریں',
      savedOn: '{{name}} کے لیے براہ راست چیٹ لنک چالو ہے۔',
      savedOff: '{{name}} کے لیے براہ راست چیٹ لنک بند ہے۔',
      url: 'چیٹ لنک',
      copy: 'لنک کاپی کریں',
      copied: 'لنک کاپی ہو گیا',
      copyFailed: 'کاپی نہیں ہو سکا۔ لنک منتخب ہے: اسے خود کاپی کریں۔',
      open: 'کھولیں',
      openLabel: 'چیٹ لنک نئے ٹیب میں کھولیں',
      off: 'لنک بند ہے۔ لنک اور اس کا کیو آر کوڈ پانے کے لیے اسے چالو کر کے محفوظ کریں۔',
      noUrl:
        'لنک ابھی نہیں بن سکتا: اس سرور کو چیٹ کا ویب پتہ معلوم نہیں۔ اپنا Hamnivo سرور چلانے والے شخص سے اسے سیٹ کرنے کو کہیں۔',
      anyWebsite: 'لنک ان ویب سائٹس پر بھی کام کرتا ہے جو آپ کی اجازت والی فہرست میں نہیں ہیں۔',
    },
    qr: {
      title: 'کیو آر کوڈ',
      description: 'اسے رسیدوں، پیکیجنگ یا پوسٹرز پر چھاپیں۔ فون کا کیمرا چیٹ کھول دیتا ہے۔',
      label: '{{name}} کی چیٹ کھولنے والا کیو آر کوڈ',
      download: 'کیو آر کوڈ ڈاؤن لوڈ کریں',
      downloaded: 'کیو آر کوڈ ڈاؤن لوڈ ہو گیا۔',
      off: 'لنک چالو ہونے پر کیو آر کوڈ یہاں دکھے گا۔',
    },
    install: {
      noAccess: 'برانڈز سنبھالنے والا کوئی شخص برانڈز اور انسٹال سے انسٹال کوڈ کاپی کر سکتا ہے۔',
      guides: 'کوڈ کو اپنی ویب سائٹ پر کیسے لگائیں',
    },
  },
};
